import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
	message?: string;
	fullScreen?: boolean;
}

export function LoadingSpinner({
	message = 'Зареждане...',
	fullScreen = false,
}: LoadingSpinnerProps) {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: fullScreen ? '100vh' : 400,
				gap: 2,
			}}>
			<CircularProgress />
			{message && (
				<Typography variant='body2' color='text.secondary'>
					{message}
				</Typography>
			)}
		</Box>
	);
}
